var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA4Motor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 26v7h-4v-6a4 4 0 00-4-4H42v-4h11v-4H25v4h11v4H24a4 4 0 00-4 4h-4v10h-4V27H8v26h4V43h4v10h4.12l8.94 8h23.2L59 55.29V46h4v7h4V26h-4zM51 49H27v-3h24v3zm0-7H27v-3h24v3zm0-7H27v-3h24v3z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A4_Motor.202bd0ee.svg";
export { SvgA4Motor as ReactComponent };